// 访客预约
export default [
    {
        path:'/visitor/index.html',
        name:'visitor-index',
        component:() => import('@/page/visitor/index'),
        meta: { keepAlive: true }
    },
    {
        path:'/visitor/owner.html',
        name:'visitor-owner',
        component:() => import('@/page/visitor/owner'),
        meta: { slide: true, keepAlive: true }
    },
    {
        path:'/visitor/staff.html',
        name:'visitor-staff',
        component:() => import('@/page/visitor/staff'),
        meta: { slide: true, keepAlive: true }
    },
    {
        path:'/visitor/apply.html',
        name:'visitor-apply',
        component:() => import('@/page/visitor/apply'),
        meta: { slide: true, keepAlive: true }
    },

    {
        path:'/visitor/history.html',
        name:'visitor-history',
        component:() => import('@/page/visitor/history'),
        meta: { slide: true,keepAlive: true }
    },
    {
        path:'/visitor/add.html',
        name:'visitor-add',
        component:() => import('@/page/visitor/add'),
        meta: { slide: true, keepAlive: true }
    },
    {
        path: "/visitor/detail.html",
        name: 'visitor-detail',
        component:() => import('@/page/visitor/detail'),
        meta: {slide: true, keepAlive: true}
    },
    {
        path:'/visitor/passport.html',
        name:'visitor-passport',
        component:() => import('@/page/visitor/passport'),
        meta: { slide: true, keepAlive: true }
    },
    {
        path:'/visitor/apply-code.html',
        name:'visitor-apply-code',
        component:() => import('@/page/visitor/apply-code'),
        meta: { slide: true }
    },

    // 特殊访客
    {
        path:'/visitor/special/index.html',
        name:'visitor-special-index',
        component:() => import('@/page/visitor/special/index'),
        meta: { keepAlive: true }
    },
    {
        path:'/visitor/special/detail.html',
        name:'visitor-special-detail',
        component:() => import('@/page/visitor/special/detail'),
        meta: { slide: true, keepAlive: true }
    },
    {
        path:'/visitor/special/settings.html',
        name:'visitor-special-settings',
        component:() => import('@/page/visitor/special/settings'),
        meta: { slide: true, keepAlive: true }
    },
    {
        path:'/visitor/special/apply-short.html',
        name:'visitor-special-apply-short',
        component:() => import('@/page/visitor/special/apply-short'),
        meta: { slide: true, keepAlive: true }
    },
    {
        path:'/visitor/special/apply-long.html',
        name:'visitor-special-apply-long',
        component:() => import('@/page/visitor/special/apply-long'),
        meta: { slide: true, keepAlive: true }
    },
    {
        path:'/visitor/special/add.html',
        name:'visitor-special-add',
        component:() => import('@/page/visitor/special/add'),
        meta: { slide: true, keepAlive: true }
    },
    {
        path:'/visitor/special/merchant.html',
        name:'visitor-special-merchant',
        component:() => import('@/page/visitor/special/merchant'),
        meta: { slide: true, keepAlive: true }
    }
]



// WEBPACK FOOTER //
// ./src/router/visitor.js